const fakeUdid = '0000000015';
function until(conditionFunction) {

    const poll = resolve => {
        if (conditionFunction())
            resolve();
        else
            setTimeout(_ => poll(resolve), 400);
    };

    return new Promise(poll);
}

const handleLocationError = (browserHasGeolocation) => {
    console.log(
            browserHasGeolocation
            ? "Error: The Geolocation service failed."
            : "Error: Your browser doesn't support geolocation."
            );
};

export const getPosition = async (cache = true) => {
    window.userPosition = null;

    if (cache) {
        window.userPosition = localStorage.getItem('position');

        if (window.userPosition) {
            try {
                return JSON.parse(window.userPosition);
            } catch (err) {

            }
        }
    }
    if (window.webkit && window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getData) {

        window.webkit.messageHandlers.getData.postMessage({
            "message": 'gps',
            "param1": "",
            "param2": ''
        });

    } else if (typeof Print !== 'undefined' && Print.postMessage) {
        var message = ['gps', '', ''];
        Print.postMessage(JSON.stringify(message));

    } else {
        window.userPosition = false;
    }
    await until(_ => window.userPosition !== null);

    if (!window.userPosition) {
        window.userPosition = {
            lat: 41.902782,
            lng: 12.496366
        };
        setTimeout(() => getPosition(cache), 7000);
    }

    localStorage.setItem('position', JSON.stringify(window.userPosition));

    return window.userPosition;
};


export const getUdid = async () => {
    window.udid = null;
    
    if (window.webkit && window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getData) {

        window.webkit.messageHandlers.getData.postMessage({
            "message": 'udid',
            "param1": "",
            "param2": ''
        });
    } else if (typeof Print !== 'undefined' && Print.postMessage) {
        var message = ['udid', '', ''];
        Print.postMessage(JSON.stringify(message));
    } else {
        window.udid = fakeUdid;
    }
    await until(_ => window.udid !== null);


    return window.udid;
};

export const setCardNumber = (cardId, password = null) => {
    if (window.webkit && window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getData) {
        window.webkit.messageHandlers.getData.postMessage({
            "message": 'set_card_number',
            "param1": cardId,
            "param2": password
        });
    } else if (typeof Print !== 'undefined' && Print.postMessage) {
        var message = ['set_card_number', cardId, password];
        Print.postMessage(JSON.stringify(message));
    } else {
        localStorage.setItem('card_number', cardId);
        localStorage.setItem('password', password);
    }
};

export const getCardStatus = async () => {
    window.cardStatus = null;
    
    if (window.webkit && window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getData) {

        window.webkit.messageHandlers.getData.postMessage({
            "message": 'login',
            "param1": "",
            "param2": ''
        });
    } else if (typeof Print !== 'undefined' && Print.postMessage) {
        var message = ['login', '', ''];
        Print.postMessage(JSON.stringify(message));
    } else {
        let cardNumber = localStorage.getItem('card_number');
        let udid = fakeUdid;
        let password = localStorage.getItem('password');
        if (cardNumber) {
            window.cardStatus = {
                cardNumber: cardNumber,
                udid: udid,
                password: password
            };
        } else {
            window.cardStatus = false;
        }
    }
    await until(_ => window.cardStatus !== null);

    return window.cardStatus;
};


